<template>
  <div class="page-box">
    <!--    头部-->
    <headerBar />
    <siteNav :selectedIndex="selectedIndex" />
    <!--    中部-->
    <div class="center-box">
      <div class="qualityControl-box">
        <div class="crumbs">首页 > 指南共识</div>
        <div class="title-nav">
          <div class="nav-li" v-for="(item, index) in navItems" :key="index" :class="{ active: activeIndex === item.id }" @click="setActive(item.id)">
            {{ item.name }}
          </div>
        </div>
        <div class="handbook-content-box" v-if="guideList.length > 0">
          <div class="handbook-list-item" v-for="(item, index) in guideList" :key="index" @click="onClickRoute(item)">
            <div class="handbook-left">{{ item.title }}</div>
            <div class="handbook-right">{{ item.createTimeFormat }}</div>
          </div>
        </div>
        <div v-if="guideList.length > 0">
          <el-pagination class="paging" background :current-page="page.number" :page-sizes="[10, 20, 30, 40]" :page-size="page.limit" layout="prev, pager, next, sizes" :total="page.total" @size-change="sizeChange"
            @current-change="currentChange" @prev-click="prevClick" @next-click="nextClick"></el-pagination>
        </div>
        <empty class="empty-margin" v-if="guideList.length <= 0"></empty>
      </div>
    </div>
    <!--    页脚-->
    <footer-bar></footer-bar>
  </div>
</template>

<script>
import headerBar from "@/components/base/headerBar";
import siteNav from "@/components/base/siteNav";
import FooterBar from "../../components/base/footerBar";
import { getPageList, getInformationType } from '@/api/home'
import empty from "@/components/empty/index";
export default {
  name: "Handbook",
  components: { FooterBar, headerBar, siteNav, empty },
  data() {
    return {
      selectedIndex: 7,
      guideList: [],
      navItems: [],
      activeIndex: '',
      page: {
        number: 1,
        limit: 10,
        total: 0,
      },
      searchTitle: '',
    }
  },
  watch: {
    "$route"(to, from) {
      this.searchTitle = to.query.title ? to.query.title : ''
      this.page.number = 1
      this.getPageList()
    },
  },
  methods: {
    onClickRoute(value) {
      let token = localStorage.getItem("x-token")
      if(token == null) {
        this.$router.push({ path: `/login` });
        return
      }
      this.$router.push({ path: `/NewsDetailsThree/${value.id}` });
    },
    setActive(index) {
      this.activeIndex = index; // 设置当前激活的项
      this.getPageList()
    },
    sizeChange(value) {
      this.page.number = 1
      this.page.limit = value
      this.getPageList()
    },
    currentChange(value) {
      this.page.number = value
      this.getPageList()
    },
    prevClick(value) {
      this.page.number = value
      this.getPageList()
    },
    nextClick(value) {
      this.page.number = value
      this.getPageList()
    },
    // 分页查询指南共识
    async getPageList() {
      await getPageList({
        number: this.page.number,
        limit: this.page.limit,
        checkStatus: 'HAVE_RELEASED',
        categories: 'GUIDE_CONSENSUS',
        type: this.activeIndex,
        title: this.searchTitle,
      }).then(res => {
        this.guideList = res.data
        this.page.total = res.totalCount
      })
    },
    // 列表查询指南共识
    async getInformationType() {
      await getInformationType({
        categories: 'GUIDE_CONSENSUS',
      }).then(res => {
        this.navItems = res.data
        this.activeIndex = res.data.length > 0 ? res.data[0].id : ''
      })
    },
    async Initialization() {
      await this.getInformationType()
      await this.getPageList()
    },
  },
  mounted() {
    var wow = new this.$wow.WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true
    });
    if (this.$route.query.title) {
      this.searchTitle = this.$route.query.title
    }
    wow.init();
    this.Initialization()
  },
}
</script>

<style lang="less" scoped>
.center-box {
  padding-bottom: 80px;
}

.handbook-content-box {
  background-color: #FFFFFF;
  flex: 1;
  margin: 20px 0 30px;
  padding-bottom: 24px;

  .handbook-list-item {
    display: flex;
    align-items: center;
    height: 70px;
    border-bottom: 1px dashed #00000033;
    box-sizing: border-box;
    text-align: left;
    padding: 0 24px;
    cursor: pointer;

    .handbook-left {
      flex: 1;
      overflow: hidden;
      color: #222222;
      font-size: 18px;
      position: relative;
      padding-left: 20px;
    }

    .handbook-left::after {
      content: '';
      position: absolute;
      left: 5px;
      top: 50%;
      transform: translateY(-50%) rotate(45deg);
      background: #9C1D22;
      width: 8px;
      height: 8px;
    }

    .handbook-right {
      color: #626365;
      font-size: 14px;
      margin-left: 10px;
    }
  }
}

/deep/.el-input__inner {
  // height: 32px;
  // border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  // color: rgba(0, 0, 0, 0.45) !important;
  // line-height: 30px;
}

/deep/.el-pagination button {
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  background: #fff !important;
  width: 32px;
  height: 32px;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pager li {
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  background: #fff !important;
  width: 32px;
  height: 32px;
  border-right: 2px;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #BD181E !important;
  color: rgba(255, 255, 255, 0.65) !important;
}
</style>


// WEBPACK FOOTER //
// src/views/Handbook/index.vue